import { difference, uniq } from "lodash";
import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import { PostUpsellStateInterface } from "../interfaces/PostUpsell/PostUpsellInterface";

const initialState: PostUpsellStateInterface = {
    cart: null,
    order: null,
    paymentMethod: null,
    addedUpsellIds: [],
};

export default function postUpsellReducer(state: PostUpsellStateInterface = initialState, action: Action): PostUpsellStateInterface {
    switch (action.type) {
        case ActionTypeEnum.POST_UPSELL_PRODUCTS_ADDED:
            return {
                ...state,
                paymentMethod: action.payload.cart.payment_method ?? state?.paymentMethod, // We only get the payment method on initial cart creation.
                cart: action.payload.cart,
                addedUpsellIds: uniq([
                    ...state.addedUpsellIds,
                    ...action.payload.upsellIds,
                ]),
            };
        case ActionTypeEnum.POST_UPSELL_PRODUCTS_REMOVED:
            return {
                ...state,
                cart: action.payload.cart,
                addedUpsellIds: difference(state.addedUpsellIds, action.payload.upsellIds),
            };
        case ActionTypeEnum.POST_UPSELL_ORDER_PLACED:
            return {
                ...state,
                order: action.payload,
            };
        default:
            return state;
    }
}
